// Shared PhonePlay logo — always links to the public site; tap target ≥ 44px.
const SIZES = {
  header: "w-12 h-12 sm:w-14 sm:h-14",
  footer: "w-16 h-16",
  hero: "w-28 h-28 sm:w-36 sm:h-36 lg:w-40 lg:h-40",
  page: "w-20 h-20 sm:w-24 sm:h-24",
};

export default function BrandLogo({ size = "header", withWordmark = false, wordmarkClass = "text-lg", testid = "brand-logo-link", className = "" }) {
  return (
    <a href="https://phoneplay.net/" data-testid={testid} aria-label="PhonePlay home" title="phoneplay.net"
      className={`inline-flex items-center gap-3 min-w-[44px] min-h-[44px] rounded-2xl ${className}`}>
      <img src={`${process.env.PUBLIC_URL}/brand/phoneplay-avatar-v2.png`} alt="PhonePlay logo" width="512" height="512"
        className={`${SIZES[size] || SIZES.header} rounded-2xl object-cover shadow-[0_0_24px_rgba(139,92,246,0.45)]`} />
      {withWordmark && <span className={`font-display font-black tracking-tight ${wordmarkClass}`}>Phone<span className="text-gradient-coins">Play</span></span>}
    </a>
  );
}
